import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getUserCompanies,
  getCompanies,
  importCompanies as importCompaniesService,
  deleteCompany as deleteCompanyService,
} from '@services/company/company.service';
import { setLatestCompany } from '@services/user/user.service';
import { logout } from './auth.reducer';

export const fetchCompanies = createAsyncThunk(
  'company/fetchCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const data = await getCompanies();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || error);
    }
  }
);

export const fetchUserCompanies = createAsyncThunk(
  'company/fetchUserCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const data = await getUserCompanies();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || error);
    }
  }
);

export const importCompanies = createAsyncThunk(
  'company/importCompanies',
  async (_, { rejectWithValue }) => {
    try {
      await importCompaniesService();
      const data = await getCompanies(); 
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao importar empresas';
      return rejectWithValue(message);
    }
  }
);

export const deleteCompany = createAsyncThunk(
  'company/deleteCompany',
  async (id, { rejectWithValue }) => {
    try {
      await deleteCompanyService(id);
      return id;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao excluir empresa';
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  companies: [],
  companiesUser: [],
  selectedCompany: null,
  companiesLoading: false,
  companiesUserLoading: false,
  companiesError: '',
  companiesUserError: '',
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setSelectedCompany: (state, { payload }) => {
      state.selectedCompany = payload;
      setLatestCompany(payload.id);
    },
    clearSelectedCompany: (state) => {
      state.selectedCompany = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.companiesLoading = true;
        state.companiesError = '';
      })
      .addCase(fetchCompanies.fulfilled, (state, { payload }) => {
        state.companiesLoading = false;
        state.companies = payload;
      })
      .addCase(fetchCompanies.rejected, (state, { payload }) => {
        state.companiesLoading = false;
        state.companiesError = payload;
      })

      .addCase(fetchUserCompanies.pending, (state) => {
        state.companiesUserLoading = true;
        state.companiesUserError = '';
      })
      .addCase(fetchUserCompanies.fulfilled, (state, { payload }) => {
        state.companiesUserLoading = false;
        state.companiesUser = payload;
      })
      .addCase(fetchUserCompanies.rejected, (state, { payload }) => {
        state.companiesUserLoading = false;
        state.companiesUserError = payload;
      })

      .addCase(importCompanies.pending, (state) => {
        state.companiesLoading = true;
        state.companiesError = '';
      })
      .addCase(importCompanies.fulfilled, (state, { payload }) => {
        state.companiesLoading = false;
        state.companies = payload;
      })
      .addCase(importCompanies.rejected, (state, { payload }) => {
        state.companiesLoading = false;
        state.companiesError = payload || 'Erro ao importar empresas';
      })

      .addCase(deleteCompany.pending, (state) => {
        state.companiesLoading = true;
        state.companiesError = '';
      })
      .addCase(deleteCompany.fulfilled, (state, { payload: id }) => {
        state.companiesLoading = false;
        state.companies = state.companies.filter(company => company.id !== id);
      })
      .addCase(deleteCompany.rejected, (state, { payload }) => {
        state.companiesLoading = false;
        state.companiesError = payload || 'Erro ao excluir empresa';
      })

      .addCase(logout, () => initialState);
  },
});

export const { setSelectedCompany, clearSelectedCompany } = companySlice.actions;
export default companySlice.reducer;
